import React from 'react';
import {createBrowserRouter, RouterProvider, Navigate, useLocation, RouteObject} from 'react-router-dom';
import { AuthProvider, useAuth } from './store/AuthContext';
import { Paths } from './paths';
import Home from "./pages/Home";
import AdminLayout from "./layout/AdminLayout";
import Admin from "./pages/admin/Admin";
import AdminUsers from "./pages/admin/AdminUsers";
import UserLayout from "./layout/UserLayout";
import User from "./pages/user/User";
import {Notfoundpage} from "./pages/Notfoundpage";
import UserObjectAnkets from "./pages/user/UserObjectAnkets";
import UserCategories from "./pages/user/UserCategories";
import UserObjects from "./pages/user/UserObjects";
import AdminCategories from "./pages/admin/AdminCategories";
import AdminObjects from "./pages/admin/AdminObjects";
import AdminObjectAnkets from "./pages/admin/AdminObjectAnkets";

const ProtectedRoute = () => {
    const { role, isAuth, isLoading } = useAuth();
    const location = useLocation();

    if (isLoading) return <div className="loading">...</div>;

    if (!isAuth) return <Home />;

    // Путь, куда юзер хотел попасть (из state) или текущий
    const targetPath = location.state?.from?.pathname || location.pathname;

    if (role === 'ADMIN') {
        // Если мы уже на странице админа (или подстранице), не редиректим на корень /admin
        if (targetPath.startsWith('/admin') && targetPath !== '/') {
            return <Navigate to={targetPath} replace />;
        }
        return <Navigate to={Paths.admin} replace />;
    }

    if (role === 'USER') {
        if (targetPath.startsWith('/user') && targetPath !== '/') {
            return <Navigate to={targetPath} replace />;
        }
        return <Navigate to={Paths.user} replace />;
    }

    return <Home />;
};

function PrivateRoute({ children, role: allowedRole }: { children: React.ReactNode, role: string }) {
    const { isAuth, role, isLoading } = useAuth();
    const location = useLocation();

    if (isLoading) return <div>Загрузка...</div>;

    if (!isAuth || role !== allowedRole) {
        return <Navigate to={Paths.home} replace state={{ from: location }} />;
    }

    return <>{children}</>;
}

export default function App() {
    const routes = [
        { path: Paths.home, element: <ProtectedRoute /> },

        // БЛОК АДМИНА
        {
            path: Paths.admin,
            element: <PrivateRoute role="ADMIN"><AdminLayout /></PrivateRoute>,
            children: [
                { index: true, element: <Admin /> },
                { path: Paths.admin_users, element: <AdminUsers /> },
                { path: Paths.admin_categories, element: <AdminCategories /> },
                { path: Paths.admin_objects, element: <AdminObjects /> },
                { path: Paths.admin_object_ankets, element: <AdminObjectAnkets /> },
                { path: '*', element: <Notfoundpage /> },
            ]
        },

        // БЛОК ПОЛЬЗОВАТЕЛЯ
        {
            path: Paths.user,
            element: <PrivateRoute role="USER"><UserLayout /></PrivateRoute>,
            children: [
                { index: true, element: <User /> },
                { path: Paths.user_categories, element: <UserCategories /> },
                { path: Paths.user_objects, element: <UserObjects /> },
                { path: Paths.user_object_ankets, element: <UserObjectAnkets /> },
                { path: '*', element: <Notfoundpage /> },
            ]
        },

        { path: '*', element: <Notfoundpage /> }
    ] as any;


    const router = React.useMemo(() => createBrowserRouter(routes), []);

    return (
        <AuthProvider>
            <RouterProvider router={router} />
        </AuthProvider>
    );
}
